module.exports = __webpack_public_path__ + "media/images/a3-c95c1358d699fc091e772442d8982a11.jpg";